import { render, staticRenderFns } from "./TreeviewDraggable.vue?vue&type=template&id=1e4a0c85&scoped=true&"
import script from "./TreeviewDraggable.vue?vue&type=script&lang=js&"
export * from "./TreeviewDraggable.vue?vue&type=script&lang=js&"
import style0 from "./TreeviewDraggable.vue?vue&type=style&index=0&id=1e4a0c85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a0c85",
  null
  
)

export default component.exports